export const PRIVACY_POLICY_URL = "https://www.dakotaprep.com/privacy-policy";
export const TERMS_URL = "https://www.dakotaprep.com/terms-conditions";
